import React, { useContext } from 'react';
import ItemImage from './ItemImage'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Link, useHistory, useLocation } from "react-router-dom";
import CartContext from '../../../contexts/CartContext';
import { pathsForTenant, useTenantPath } from '../../../utils/tenantPath';
import Price from './Price';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import IfTrue from '../../conditions/IfTrue';
import PriceRange from './PriceRange';
import ItemBanner from './ItemBanner';

type Props = ItemProps & {
}

const Item = ({ item }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [display, setDisplay] = React.useState<undefined | string>('flex');
  const history = useHistory();
  const location = useLocation();
  const activePath = useTenantPath();
  // Cross-tenant search results stamp item.tenant so the card links into
  // the right shop even when the URL says we're inside the other one.
  const path = item.tenant ? pathsForTenant(item.tenant) : activePath;
  // When viewing one of the "highlight" landing pages (New Arrivals,
  // Best Sellers, Hot Sellers), route item clicks under that same
  // path so Store's URL match keeps the grid mounted as the dialog
  // background. Direct pathname regex rather than `useRouteMatch`
  // because the latter was returning null under the nested-Switch +
  // background-location setup. The cross-tenant case (item.tenant
  // set) can't happen on those pages today — they're single-tenant —
  // so falling through to the standard /item/:itemId path is safe.
  const landingSegment = /\/r\/[^/]+\/new-arrivals(\/|$)/.test(location.pathname)
    ? 'new-arrivals'
    : /\/r\/[^/]+\/best-sellers(\/|$)/.test(location.pathname)
    ? 'best-sellers'
    : /\/r\/[^/]+\/hot-sellers(\/|$)/.test(location.pathname)
    ? 'hot-sellers'
    : null;
  const itemHref = landingSegment && !item.tenant
    ? `/r/${path.store}/${landingSegment}/item/${item.id}`
    : path.item(item.id);

  // Get the cart from the context
  const {cart, setCartState} = useContext(CartContext);
  const [movingItem, setMovingItem] = React.useState<undefined | ICategory >(undefined);

  const handleClose = (reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const hiddenClass = item.hidden ? 'hidden' : '';
  const newCategoryName = movingItem ? movingItem.name : '';


  const isGroup = item?.group?.enabled && !item?.group?.variantName;
  const stockCounter = isGroup ?
    (item.group?.variantSummary?.stock) :
    Object.keys(item.inventory).reduce((sum, key) => sum + item.inventory[key].count, 0);
  
  if (isGroup) {
    const priceHigh = item.group?.variantSummary?.priceHigh;
    const priceLow = item.group?.variantSummary?.priceLow;
    
    return (
      <>
      <Card className={'item-card ' + hiddenClass}>
        <Link className='card-link' to={{pathname: itemHref, state: {from: location.pathname, background: location}}}>
        <CardContent className='card'>
          <IfTrue condition={item?.discontinued}>
            <div className='discontinued-banner'>Discontinued</div>
          </IfTrue>
          <ItemImage id={item.imageId} height={180} title={item.name} timestamp={item.updatedAt} imageRoot={item.imageRoot}/>
          <div className={'card-title'} color="textPrimary">
            <div className='brand-name'>{item.brand}</div>
            <div className='item-name'>{item.name}</div>
          </div>
          <div>
            <PriceRange priceLow={priceLow as number} priceHigh={priceHigh as number}/>
          </div>
          <IfTrue condition={item.discontinued}>
            <div className='stock-count space-above'>{stockCounter} left in stock</div>
          </IfTrue>
          <ItemBanner item={item}/>
        </CardContent>
        </Link>
      </Card>
      </>
    )

  }

  return (
    <>
    <Card className={'item-card ' + hiddenClass}>
      <Snackbar open={open} autoHideDuration={6000} onClose={(event?: any, reason?: string) => {handleClose(reason)}}>
        <Alert onClose={(event?: any, reason?: string) => {handleClose(reason)}} severity="success">
          Added {item.name} to cart.
        </Alert>
      </Snackbar>
      <Link className='card-link' to={{pathname: itemHref, state: {from: location.pathname, background: location}}}>
      <CardContent className='card'>
        <IfTrue condition={item?.discontinued}>
          <div className='discontinued-banner'>Discontinued</div>
        </IfTrue>
          <ItemImage id={item.imageId} height={180} title={item.name} timestamp={item.updatedAt} imageRoot={item.imageRoot}/>
          <div className={'card-title'} color="textPrimary">
            <div className='brand-name'>{item.brand}</div>
            <div className='item-name'>{item.name}</div>
          </div>
          <div>
            <Price price={item.price}/>
          </div>
          <IfTrue condition={item.discontinued}>
            <div className='stock-count space-above'>{stockCounter} left in stock</div>
          </IfTrue>

        <ItemBanner item={item}/>
      </CardContent>
      </Link>
    </Card>
    </>
  )
}

export default Item